<template>
  <div v-if="show" class="modal-overlay">
    <div class="modal-content">
      <div class="modal-header">
        <h3>Gestione Ordini Automatici</h3>
        <button class="close-btn" @click="$emit('close')">&times;</button>
      </div>
      
      <div class="modal-body">
        <div v-if="!selectedPartner" class="partner-list">
          <table class="table">
            <thead>
              <tr>
                <th>Fornitore</th>
                <th>Automatico</th>
                <th>Azioni</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="partner in partners" :key="partner._id">
                <td>{{ partner.nome }}</td>
                <td>
                  <span :class="['badge', partner.automatico ? 'bg-success' : 'bg-secondary']">
                    {{ partner.automatico ? 'SI' : 'NO' }}
                  </span>
                </td>
                <td>
                  <button class="btn btn-sm btn-primary" @click="selectPartner(partner)">Dettagli</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else class="partner-details">
          <button class="btn btn-sm btn-outline-secondary mb-3" @click="selectedPartner = null">Indietro</button>
          <h4>Dettagli {{ selectedPartner.nome }}</h4>
          
          <div class="form-group mb-2">
            <label>Nome Fornitore</label>
            <input type="text" v-model="selectedPartner.nome" class="form-control" />
          </div>

          <div class="form-group mb-2">
            <label>Email</label>
            <input type="email" v-model="selectedPartner.email" class="form-control" />
          </div>

          <div class="form-group mb-2">
            <label>Telefono</label>
            <input type="text" v-model="selectedPartner.telefono" class="form-control" />
          </div>

          <div class="form-group mb-2">
            <label>Referenze Fornitore</label>
            <textarea v-model="selectedPartner.referenze" class="form-control" rows="2"></textarea>
          </div>

          <div class="form-check mb-2">
            <input type="checkbox" v-model="selectedPartner.automatico" class="form-check-input" id="autoCheck">
            <label class="form-check-label" for="autoCheck">Attiva Ordine Automatico</label>
          </div>

          <div class="form-group mb-2">
            <label>Metodo Invio</label>
            <div class="form-check">
              <input type="checkbox" v-model="selectedPartner.alert_email" class="form-check-input" id="mailCheck">
              <label class="form-check-label" for="mailCheck">Email</label>
            </div>
            <div class="form-check">
              <input type="checkbox" v-model="selectedPartner.alert_sms" class="form-check-input" id="smsCheck">
              <label class="form-check-label" for="smsCheck">Messaggio (SMS)</label>
            </div>
          </div>

          <div class="form-group mb-2">
            <label>Giorni Consegna/Ordine</label>
            <div class="days-selector">
              <label v-for="(day, index) in days" :key="index" class="day-label">
                <input type="checkbox" :value="index + 1" v-model="selectedPartner.giorno_ordine">
                {{ day }}
              </label>
            </div>
          </div>

          <h5>Prodotti da Ordinare (Sotto Scorta)</h5>
          <div class="products-list mb-3" v-if="currentOrders.length > 0">
             <table class="table table-sm table-warning">
                <thead>
                  <tr>
                    <th>Prodotto</th>
                    <th>Giacenza</th>
                    <th>Minimo</th>
                    <th>Da Ordinare</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="prod in currentOrders" :key="prod.code">
                    <td>{{ prod.descrizi || prod.nome }}</td>
                    <td>{{ prod.quantita }}</td>
                    <td>{{ prod.quantitamin }}</td>
                    <td>
                      <input 
                        type="number" 
                        class="form-control form-control-sm w-75" 
                        v-model="prod.quantitaordine" 
                        @change="updateQuantitaOrdine(prod)"
                      />
                    </td>
                  </tr>
                </tbody>
             </table>
          </div>
          <p v-else class="text-muted">Nessun prodotto attualmente in sotto scorta per questo fornitore.</p>

          <h5>Tutti i Prodotti Collegati</h5>
          <div class="products-list">
             <table class="table table-sm">
                <thead>
                  <tr>
                    <th>Codice</th>
                    <th>Descrizione</th>
                    <th>Azioni</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="prod in partnerProducts" :key="prod.code">
                    <td>{{ prod.code }}</td>
                    <td>{{ prod.descrizi || prod.nome }}</td>
                    <td>
                      <button class="btn btn-sm btn-outline-danger" @click="unlinkProduct(prod.code)">Scollega</button>
                    </td>
                  </tr>
                </tbody>
             </table>
             <div class="add-product mt-2 p-2 border rounded bg-light">
                <label class="d-block small text-muted">Aggiungi nuovo prodotto al fornitore:</label>
                <select v-model="productToLink" class="form-control form-control-sm d-inline-block w-75 mr-2">
                   <option disabled value="">Seleziona un prodotto...</option>
                   <option v-for="p in availableProducts" :key="p.code" :value="p.code">
                     {{ p.descrizi || p.nome }}
                   </option>
                </select>
                <button class="btn btn-sm btn-success" @click="linkProduct">Collega</button>
             </div>
          </div>

          <div class="modal-footer mt-4">
            <button class="btn btn-primary" @click="savePartner">Salva Modifiche</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '../store/store.js'

export default {
  name: 'AutomaticOrderModal',
  props: ['show', 'allProducts'],
  data() {
    return {
      partners: [],
      selectedPartner: null,
      partnerProducts: [],
      allProductsForLink: [],
      productToLink: '',
      days: ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'],
      store
    }
  },
  computed: {
    availableProducts() {
      // Show products NOT linked to anyone, or linked but NOT to this partner (optional, usually products have 1 supplier)
      return this.allProductsForLink.filter(p => !p.fornitore_id || p.fornitore_id === '');
    },
    currentOrders() {
      if (!this.selectedPartner || !this.selectedPartner.prodotti) return [];
      return this.allProducts.filter(p => this.selectedPartner.prodotti.includes(p.code));
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.fetchPartners();
        this.fetchAllProducts();
      }
    }
  },
  methods: {
    fetchAllProducts() {
       this.axios.post(this.store.path+'displayProduct',{headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
         this.allProductsForLink = response.data.messaggio;
      });
    },
    fetchPartners() {
      this.axios.get(this.store.path + 'partners', {
        headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
      }).then(res => {
        this.partners = res.data.messaggio;
      });
    },
    selectPartner(partner) {
      this.selectedPartner = { ...partner };
      this.fetchPartnerProducts();
    },
    fetchPartnerProducts() {
      this.axios.get(this.store.path + 'partnerProducts/' + this.selectedPartner._id, {
        headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
      }).then(res => {
        this.partnerProducts = res.data.messaggio;
      });
    },
    savePartner() {
      this.axios.post(this.store.path + 'updatePartnerAutoOrder', {
        partnerId: this.selectedPartner._id,
        ...this.selectedPartner,
        headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
      }).then(() => {
        this.fetchPartners();
        this.selectedPartner = null;
        alert('Configurazione salvata con successo');
      });
    },
    linkProduct() {
      if (!this.productToLink) return;
      this.axios.post(this.store.path + 'linkProductToPartner', {
        productCode: this.productToLink,
        partnerId: this.selectedPartner._id,
        headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
      }).then(() => {
        if (!this.selectedPartner.prodotti) this.selectedPartner.prodotti = [];
        this.selectedPartner.prodotti.push(this.productToLink);
        this.fetchPartnerProducts();
        this.fetchAllProducts(); // Refresh available list
        this.productToLink = '';
      });
    },
    unlinkProduct(code) {
       this.axios.post(this.store.path + 'unlinkProductFromPartner', {
        productCode: code,
        partnerId: this.selectedPartner._id,
        headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
      }).then(() => {
        this.selectedPartner.prodotti = this.selectedPartner.prodotti.filter(c => c !== code);
        this.fetchPartnerProducts();
        this.fetchAllProducts();
      });
    },
    updateQuantitaOrdine(product) {
       this.axios.post(this.store.path + 'updateQuantita', {
        code: product.code,
        quantitaordine: product.quantitaordine,
        headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
      }).then(() => {
        console.log('Quantità aggiornata con successo');
      });
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 80%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
}
.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}
.days-selector {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.day-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.9em;
}
.products-list {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #eee;
  padding: 5px;
}
</style>
